
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import CodeInput from '../../global/components/CodeInput.vue'

@Component({
  components: { CodeInput }
})
export default class PasswordResetTwoFactorCard extends Vue {
  @Prop({ type: String, default: null })
  private readonly error!: string

  @Prop({ type: Boolean, default: false })
  private readonly loading!: boolean

  get field() {
    return this.$refs.field as CodeInput
  }

  onComplete(code: string) {
    this.$emit('complete', code)
  }

  back() {
    this.$emit('back')
  }
}
